export function uniqueName(name: string, nameArray: string[]): string {
	let newName = name;

	while (nameArray.includes(newName)) {
		const match = newName.match(/^(.*?)( copy (\d+))?$/);
		const baseName = match[1];
		const copyCount = parseInt(match[3] || "0", 10);
		newName = `${baseName} copy ${copyCount + 1}`;
	}

	return newName;
}
